"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.secureCredentials = void 0;
const types_1 = require("../../../types");
exports.secureCredentials = [
    types_1.CredentialsKeyEnum.ApiKey,
    types_1.CredentialsKeyEnum.ApiToken,
    types_1.CredentialsKeyEnum.SecretKey,
    types_1.CredentialsKeyEnum.Token,
    types_1.CredentialsKeyEnum.Password,
    types_1.CredentialsKeyEnum.ServiceAccount,
];
//# sourceMappingURL=secure-credentials.js.map